import { Injectable } from '@angular/core';
import { FilterAssistQuery } from '../../../interfaces/filter-assist-query';
import { ContactsQuery } from '../../../models/contacts-query';
import { ContactFilterService } from '../services/contact-filter.service';
import { Observable, of } from 'rxjs';
import { FilterAssist } from '../../../models/filter-assist';
import { CountriesService } from '../services/countries.service';
import { FilterCategoryEnum } from '../../../enum/filter-category.enum';

@Injectable({
    providedIn: 'root'
})
export class ContactCardFilterService implements FilterAssistQuery<ContactsQuery> {

    private readonly CONTACT_TEXT = 'CONTACT_TEXT';
    private readonly CONTACT_COUNTRY = 'CONTACT_COUNTRY';

    constructor(private contactFilterService: ContactFilterService, private countriesService: CountriesService) {
        this.contactFilterService.registerFilters(this);
    }

    protected description(id: string, parameter: any): string {
        switch (id) {
            case this.CONTACT_TEXT:
                return $localize`Address contains "${parameter}"`;
            case this.CONTACT_COUNTRY:
                const country = this.countriesService.countryName(parameter);
                return $localize`Country is ${country}`;
        }
    }

    active(query: ContactsQuery): Observable<FilterAssist[]> {
        const list = [];
        if (query.filter) {
            list.push({
                id: this.CONTACT_TEXT,
                description: this.description(this.CONTACT_TEXT, query.filter),
                parameter: query.filter,
                score: 10
            });
        }
        if (query.country) {
            list.push({
                id: this.CONTACT_COUNTRY,
                description: this.description(this.CONTACT_COUNTRY, query.country),
                parameter: query.country,
                score: 10
            });
        }
        return of(list);
    }

    apply(id: string, parameter: any, query: ContactsQuery): void {
        switch (id) {
            case this.CONTACT_TEXT:
                query.filter = parameter;
                break;
            case this.CONTACT_COUNTRY:
                query.country = parameter;
        }
    }

    ids(): string[] {
        return [ this.CONTACT_TEXT, this.CONTACT_COUNTRY ];
    }

    match(terms: string): Observable<FilterAssist[]> {
        const output = [];
        if (terms.length < 2) {
            return of(output);
        }
        this.countriesService.countryFilter(terms).slice(0, 3).forEach((code) => {
            output.push({
                id: this.CONTACT_COUNTRY,
                parameter: code,
                description: this.description(this.CONTACT_COUNTRY, code),
                score: 50,
                category: FilterCategoryEnum.COUNTRY
            });
        });
        output.push({
            id: this.CONTACT_TEXT,
            parameter: terms,
            description: this.description(this.CONTACT_TEXT, terms),
            score: 100,
            category: FilterCategoryEnum.CARD
        });
        return of(output);
    }

    unapply(id: string, query: ContactsQuery): void {
        switch (id) {
            case this.CONTACT_COUNTRY:
                query.country = null;
                break;
            case this.CONTACT_TEXT:
                query.filter = null;
                break;
        }
    }
}
